const loginStyles = (theme) => {
  return {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    loginPageCont: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: '#000',
    },
    block: {
      display: 'block',
    },
    background: {
      backgroundSize: 'cover',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
    },
    logoSmall: {
      position: 'absolute',
      top: theme.spacing(2),
      left: theme.spacing(2),
      float: 'left',
      [theme.breakpoints.down('lg')]: {
        top: theme.spacing(1),
        left: theme.spacing(1),
        float: 'left',
      },
      [theme.breakpoints.down('xs')]: {
        top: theme.spacing(1),
        left: theme.spacing(10),
        float: 'left',
      },
    },
    mainContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    square: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      backgroundColor: 'transparent',
    },
    logo: {
      objectFit: 'cover',
      overflow: 'hidden',
      width: theme.spacing(12),
      borderRadius: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(8),
      },
    },
    name: {
      fontWeight: 'bold',
      fontSize: theme.spacing(3),
      fontStyle: 'italic',

      [theme.breakpoints.down('md')]: {
        fontSize: theme.spacing(2),
      },
    },
    card: {
      backgroundRepeat: 'no-repeat',

      backgroundSize: 'cover',

      minWidth: '80%',
      overflow: 'hidden',
      backgroundColor: '#fff', //191838 --old

      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    formGridCont: {
      [theme.breakpoints.up('md')]: {
        borderLeftWidth: theme.spacing(0.2),
        borderLeftStyle: 'solid',
        borderLeftColor: '#9999a2',
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      width: 'auto',
      minWidth: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    inputField: {
      '& .MuiInput-underline:after': {
        borderBottomColor: '#000', //9999a2 --old
        borderBottomWidth: theme.spacing(0.1),
      },
      '& .MuiInput-underline:before': {
        borderBottomColor: '#000',
        borderBottomWidth: theme.spacing(0.1),
      },
    },
    signinBtn: {
      marginTop: '1rem',

      backgroundColor: '#3949AB', //125AB8 --old
      color: '#fff',
      // borderColor: '#125AB8',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        color: '#00acc1',
        backgroundColor: '#fff', //125AB8 --old
        borderColor: '#00acc1',
      },
    },
    title: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    captionText: {
      color: '#000',
    },
    optionalContainer: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    registerBtn: {
      color: '#3949AB', //D1373F // //90103B-praveen tms red
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        color: '#00acc1',
      },
    },
    socialContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    imageCls: {
      maxHeight: 160,
      width: theme.spacing(20),
      height: theme.spacing(20),
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(3.2),
      // backgroundColor: '#D7DBDD',
    },
    imgGrid: {
      height: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    tagLine: {
      fontWeight: 450,
    },
    dummy: {
      width: theme.spacing(1.5),
    },
    policyLink: {
      color: '#3949AB',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      fontWeight: '700',
      '&:hover': {
        color: '#00acc1',
      },
    },
    frgtPswd: {
      color: '#00acc1',
      cursor: 'pointer',
      textDecoration: 'none',
      alignSelf: 'flex-end',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    termsContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      alignSelf: 'flex-end',
      marginTop: 5,
      paddingTop: 3,
      textAlign: 'justify',
    },
    termsText: {
      fontSize: theme.spacing(1.2),
      // color: '#3949AB'
    },
  };
};

export default loginStyles;
